const markdownStyles = {
	root: { width: "100%" },
	view: {},
	codeBlock: {
		borderWidth: 1,
		borderColor: "#CCCCCC",
		backgroundColor: "#f5f5f5",
		padding: 10,
		borderRadius: 4,
	},
	codeInline: {
		borderWidth: 1,
		borderColor: "#CCCCCC",
		backgroundColor: "#f5f5f5",
		padding: 10,
		borderRadius: 4,
	},
	del: {
		backgroundColor: "#000000",
	},
	em: {
		fontStyle: "italic",
	},
	headingContainer: {
		flexDirection: "row"
	},
	heading: {
		marginBottom: 10,
	},
	heading1: {
		fontSize: 32
	},
	heading2: {
		fontSize: 24,
	},
	heading3: {
		fontSize: 18,
	},
	heading4: {
		fontSize: 16,
	},
	heading5: {
		fontSize: 13,
	},
	heading6: {
		fontSize: 11,
	},
	hr: {
		backgroundColor: "lightgray",
		height: 2,
		marginTop: 10,
		marginBottom: 10,
	},
	blockquote: {
		paddingHorizontal: 10,
		paddingVertical: 5,
		margin: 10,
		backgroundColor: "#CCCCCC",
	},
	inlineCode: {
		borderRadius: 3,
		borderWidth: 1,
		fontFamily: "Courier",
		fontWeight: "bold",
	},
	list: {
		width: "100%"
	},
	listItem: {
		flex: 1,
		flexWrap: "wrap",
		marginBottom: 5
	},
	listUnordered: {
		marginTop: 5
	},

	listUnorderedItem: {
		flexDirection: "row",
		justifyContent: "flex-start",
		flex: 1,
		flexGrow: 0
	},

	listUnorderedItemIcon: {
		fontWeight: "bold",
		marginLeft: 0,
		marginRight: 5,
		lineHeight: 36,
	},
	listUnorderedItemText: {
		fontSize: 20,
		lineHeight: 20,
	},

	listOrdered: {
		marginTop: 5
	},
	listOrderedItem: {
		flexDirection: "row",
		flex: 1,
		flexGrow: 0
	},
	listOrderedItemIcon: {
		fontWeight: "bold",
		marginLeft: 0,
		marginRight: 5,
		lineHeight: 36
	},
	listOrderedItemText: {
		fontWeight: "bold",
		lineHeight: 20,
	},
	paragraph: {
		marginTop: 5,
		marginBottom: 5,
		flexWrap: "wrap",
		flexDirection: "row",
		alignItems: "flex-start",
		justifyContent: "flex-start"

	},
	hardbreak: {
		width: "100%",
		height: 1,
	},
	strong: {
		fontWeight: "bold",
	},
	table: {
		borderWidth: 1,
		borderColor: "#000000",
		borderRadius: 3,
	},
	tableHeader: {},
	tableHeaderCell: {
		flex: 1,
		// color: "#000000",
		padding: 5,
		// backgroundColor: "green",
		borderRightWidth: 1,
		borderRightColor: "black",
		backgroundColor: "#eeeeee"
	},
	tableRow: {
		borderBottomWidth: 1,
		borderColor: "#000000",
		flexDirection: "row",
	},
	tableRowCell: {
		flex: 1,
		padding: 5,
		borderRightWidth: 1,
		borderRightColor: "black"
	},
	text: {
	},
	strikethrough: {
		textDecorationLine: "line-through",
	},
	link: {
		textDecorationLine: "underline",
	},
	blocklink: {
		flex: 1,
		//   borderColor: "#000000",
		//   borderBottomWidth: 1,

	},
	u: {
		borderColor: "#000000",
		borderBottomWidth: 1,
	},
	image: {
		resizeMode: "contain"
	},
};

export default markdownStyles;